import { createSlice } from '@reduxjs/toolkit';
import { fetchTrainingReportData } from '../thunks/trainingReportsThunks/thunk';

const initialState = {
  loading: false,
  error: null,
  data: {
    reportData: [],
    lastGenerated: null,
    reportType: null,
  },
};

const trainingReportsSlice = createSlice({
  name: 'trainingReports',
  initialState,
  reducers: {
    clearReportData: (state) => {
      state.data.reportData = [];
      state.data.lastGenerated = null;
      state.data.reportType = null;
    },
    setReportType: (state, action) => {
      state.data.reportType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch training report data
      .addCase(fetchTrainingReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainingReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.data.reportData = action.payload;
        state.data.lastGenerated = new Date().toISOString();
        state.error = null;
      })
      .addCase(fetchTrainingReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch training report data';
        state.data.reportData = [];
      });
  },
});

export const { clearReportData, setReportType } = trainingReportsSlice.actions;
export default trainingReportsSlice.reducer;
